/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { MixRatioDefinitionBase } from "../../../../schema/generated/MixRatioDefinition";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class MixRatioDefinitionDataApi extends EntityDataApi<MixRatioDefinitionBase> {
  public readonly def = idbEntityDefs.MixRatioDefinition;
}